import { close, onEscape, open } from "./dom.js";

export function initMobileMenu() {
  const openButton = document.querySelector(".header__mobile-menu-icon");
  const closeButton = document.querySelector(".header__mobile-menu-close-icon");
  const panel = document.querySelector(".header__mobile-menu-container");
  const overlay = document.querySelector(".header__mobile-menu-overlay");

  if (!openButton || !closeButton || !panel || !overlay) {
    return;
  }

  const closeMenu = () => close(panel, overlay);

  openButton.addEventListener("click", () => open(panel, overlay));
  closeButton.addEventListener("click", closeMenu);
  onEscape(panel, closeMenu);
}
